export default __webpack_public_path__ + "static/media/thumbnail.3826b34c.png";